module.exports = __webpack_public_path__ + "img/calendar-x-fill.47449dc5.svg";